import React from 'react';
import { useTranslation } from 'react-i18next';
import { loadChildVisit, monitoringModule } from '../MonitoringDucks';
import { columns } from './MonitoringChildrenColumns';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import ExportFile from './ExportFile';
import FilterDatePicker from '../../../components/TableFilter/ColumnsFilters/FilterDatePicker';
import FilterTreeSelect from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const defaultValues = {
  dateMin: moment()
    .add(-20, 'd')
    .format('YYYY-MM-DDTHH:mm:ss'),
  dateMax: moment().format('YYYY-MM-DDTHH:mm:ss')
};

export default function MonitoringChildren() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { nextPage, filter } = useTableFilter(filter => {
    dispatch(loadChildVisit(filter))
  }, {
    pageNumber: 1,
    pageSize: 26,
    ...defaultValues
  });
  const data = useSelector(state => state[monitoringModule].tableData);
  const loading = useSelector(state => state[monitoringModule].loading);
  return (
    <div>
      <Box className="flex justify-between items-center mr2 mb1" style={{
        width: 900
      }}>
        <FilterDatePicker
          name="dateMin"
          placeholder={t('monitoring_fromDate')}
          style={{ marginRight: 10, width: 230, minWidth: 230 }}
        />
        <FilterDatePicker
          name="dateMax"
          placeholder={t('monitoring_toDate')}
          style={{ marginRight: 10, width: 230, minWidth: 230 }}
        />
        <Typography style={{fontSize: '12px', width: '200px', minWidth: '130px' }}>{t('monitoring_location')}</Typography>
        <FilterTreeSelect
          lookupId="60"
          name="serviceProviderLocation"
          lang={i18n.language}
          filter={item => item.ARM_gu === 'true'}
        />
      </Box>
      <ExportFile filter={filter}/>
      <StaticTablePagination
        loading={loading}
        sortable={false}
        columns={columns({
          t,
          lang: i18n.language
        })}
        data={data.content}
        totalElements={data.totalElements}
        onClickLoadMore={() => nextPage()}
      />
    </div>
  );
}
